<template>
  <div class="radio-LP" :class="[inlineClass, { disabled: disabled }]">
    <input
      :id="cbId"
      class=""
      :class="[
        { 'is-valid': valid === true },
        { 'is-invalid': valid === false },
      ]"
      type="radio"
      :disabled="disabled"
      :value="name"
      v-model="model"
    />
    <label :for="cbId" class="radioLabel">
      <slot></slot>
    </label>
  </div>
</template>
<script>
import { randomString } from "./stringUtils";
export default {
  name: "base-radio",
  props: {
    name: {
      type: [String, Number],
      description: "Radio label",
    },
    disabled: {
      type: Boolean,
      description: "Whether radio is disabled",
    },
    value: {
      type: [String, Boolean],
      description: "Radio value",
    },
    inline: {
      type: Boolean,
      description: "Whether radio is inline",
    },
    valid: {
      type: Boolean,
    },
    table: {
      type: Boolean,
    },
  },
  data() {
    return {
      cbId: "",
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        if (this.table) {
          this.value = value;
        }
      },
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return "";
    },
  },
  mounted() {
    this.cbId = randomString();
    this.valid = null;
  },
};
</script>
<style lang="scss">
.radio-LP {
  display: flex;
  align-items: center;
  margin-top: 6px;
  .radioLabel {
    margin: 0px 6px 0;
    font-size: 0.875rem;
  }
}
</style>
